import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Spin, Alert, Tabs } from "antd";
import { BASE_URL } from "../../constants/Url";
import { useSelector } from "react-redux";

const EmailModal = ({
  open,
  email,
  setEmail,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  emailCode,
  setEmailCode,
  handleSendCode,
  handleEmailContinue,
  loading,
  setError,
  error,
  countdown,
  t,
  handleClose,
  loadingNew,
  oldPassword,
  setOldPassword
}) => {
  const [form] = Form.useForm();
  const user = useSelector((state) => state.authReducer);
  const hasEmail = !!user?.user?.email;
  const [activeTab, setActiveTab] = useState('changeEmail');

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setActiveTab('changeEmail');
    } else {
      if (hasEmail && user?.user?.email) {
        if (setEmail) setEmail(user?.user?.email);
        form.setFieldsValue({ email: user?.user?.email });
      }
    }
  }, [form, open, hasEmail, user?.user?.email, setEmail]);

  // UI for Email Input
  const renderEmailInput = () => (
    <Form.Item name="email">
      <Input
        autoComplete="off"
        size="large"
        placeholder={t("text_enter_email")}
        value={email}
        onChange={(e) => {
          if (setError) setError(null);
          if (setEmail) setEmail(e.target.value);
        }}
      />
    </Form.Item>
  );

  // UI for Code Input
  const renderCodeInput = () => {
    const isSameEmail = hasEmail && activeTab === 'changeEmail' && email === user?.user?.email;
    const canGetCode = !loadingNew && countdown === 0 && email && !isSameEmail;

    return (
      <Form.Item name="emailCode">
        <Input
          size="large"
          placeholder={t("text_enter_code")}
          maxLength={6}
          value={emailCode}
          onChange={(e) => {
            if (setError) setError(null);
            if (setEmailCode) setEmailCode(e.target.value);
          }}
          suffix={
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                if (canGetCode) {
                  handleSendCode();
                }
              }}
              style={{
                color: canGetCode ? '#4196ff' : '#ccc',
                cursor: canGetCode ? 'pointer' : 'not-allowed',
              }}
            >
              {loadingNew ? <Spin size="small" /> : countdown > 0 ? `${countdown}s` : t("text_get_codes")}
            </a>
          }
        />
      </Form.Item>
    );
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      title={t("")}
    >
      <Spin spinning={loading}>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div className='flex items-center mb-3' style={{ display: 'flex', justifyContent: 'center' }}>
            <img alt='ESI-Logo' role='button' src={BASE_URL + "/logo.svg"} className='esi-logo' />
          </div>
          <p style={{ color: '#888' }}>
            {t("text_leading_online_hair_magazine")}
          </p>
        </div>

        {error && <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />}

        <Form layout="vertical" form={form}>
          {hasEmail ? (
            <>
              <div className="flex items-center gap-2 mb-2 text-[14px]" style={{ marginBottom: '20px' }}>
                  <span 
                      className={`cursor-pointer ${activeTab === 'changeEmail' ? 'font-bold text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}
                      onClick={() => { setActiveTab('changeEmail'); if (setError) setError(null); }}
                  >
                      {t('text_change_email')}
                  </span>
              </div>

              {activeTab === 'changeEmail' ? (
                <>
                  <div style={{ marginBottom: "20px" }}>
                    <p style={{ color: '#888' }}>{t("text_enter_new_email")}</p>
                  </div>
                  {renderEmailInput()}
                  {renderCodeInput()}
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClick={() => handleEmailContinue('changeEmail')}
                    disabled={loading || !email || !emailCode || emailCode?.length !== 6}
                  >
                    {loading ? <Spin size="small" /> : t("Save")}
                  </Button>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: "20px" }}>
                    <p style={{ color: '#888' }}>{t("text_enter_new_password")}</p>
                  </div>
                  {/* <Form.Item name="oldPassword">
                    <Input.Password
                      size="large"
                      placeholder={t("text_current_password")}
                      value={oldPassword}
                      onChange={(e) => {
                        if (setOldPassword) setOldPassword(e.target.value);
                        if (setError) setError(null);
                      }}
                    />
                  </Form.Item> */}
                  <Form.Item name="password">
                    <Input.Password
                      autoComplete="new-password"
                      size="large"
                      placeholder={t("text_new_password")}
                      value={password}
                      onChange={(e) => { 
                        if (setPassword) setPassword(e.target.value); 
                        if (setError) setError(null); 
                      }}
                    />
                  </Form.Item>
                  <Form.Item name="confirmPassword">
                    <Input.Password
                      autoComplete="new-password"
                      size="large"
                      placeholder={t("text_confirm_new_password")}
                      value={confirmPassword}
                      onChange={(e) => { 
                        if (setConfirmPassword) setConfirmPassword(e.target.value); 
                        if (setError) setError(null); 
                      }}
                    />
                  </Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClick={() => handleEmailContinue('resetPassword')}
                    disabled={loading || !password || !confirmPassword } //|| !oldPassword
                  >
                    {loading ? <Spin size="small" /> : t("Save")}
                  </Button>
                </>
              )}
            </>
          ) : (
            <>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                <p className='labelLogin'>{t("text_bind_email")}</p>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: "30px" }}>
                <p style={{ color: '#888' }}>
                  {t("text_enter_bind_email")}
                </p>
              </div>

              {renderEmailInput()}
              {renderCodeInput()}

              {/* <Form.Item name="password">
                <Input.Password
                  autoComplete="new-password"
                  size="large"
                  placeholder={t("text_enter_password")}
                  value={password}
                  onChange={(e) => { 
                    if (setPassword) setPassword(e.target.value); 
                    if (setError) setError(null); 
                  }}
                />
              </Form.Item>

              <Form.Item name="confirmPassword">
                <Input.Password
                  autoComplete="new-password"
                  size="large"
                  placeholder={t("text_confirm_password")}
                  value={confirmPassword}
                  onChange={(e) => { 
                    if (setConfirmPassword) setConfirmPassword(e.target.value); 
                    if (setError) setError(null); 
                  }}
                />
              </Form.Item> */}

              <Button
                type="primary"
                size="large"
                block
                onClick={() => handleEmailContinue('bindEmail')}
                disabled={loading || !email || !emailCode}
              >
                {loading ? <Spin size="small" /> : t("Save")}
              </Button>
            </>
          )}
        </Form>
      </Spin>
    </Modal>
  );
};

export default EmailModal;
